export default {
	SHIPPING_METHOD: [
		{
			id: "shipping-001",
			name: "JNE - Regular",
			img_logo: "/images/jne.svg",
			price: 9000,
			eta: "1-3 days",
		},
		{
			id: "shipping-002",
			name: "SiCepat - Regular",
			img_logo: "/images/sicepat.svg",
			price: 9000,
			eta: "1-3 days",
		},
	],
	STATUS_SHIPPING: [
		{
			title: "Order Created",
			date: "15 OKT 2021 10:35",
		},
		{
			title: "Order Confirmed",
			date: "15 OKT 2021 10:35",
		},
		{
			title: "Awaiting Pickup",
			date: "15 OKT 2021 10:35",
		},
		{
			title: "In Delivery",
			date: "15 OKT 2021 10:35",
		},
		{
			title: "Order Completed",
			date: "15 OKT 2021 10:35",
		},
	],
	SORT_BY: [
		{
			id: "price_asc",
			link: "",
			name: "Lowest Price",
		},
		{
			id: "price_desc",
			link: "",
			name: "Highest Price",
		},
		// {
		// 	id: "highest_discount",
		// 	link: "",
		// 	name: "Highest Discount",
		// },
		{
			id: "latest",
			link: "",
			name: "Newest",
		},
		{
			id: "oldest",
			link: "",
			name: "Oldest",
		},
		{
			id: "name_asc",
			link: "",
			name: "A-Z",
		},
		{
			id: "name_desc",
			link: "",
			name: "Z-A",
		},
	],
	PAYMENT: [
		// {
		// 	code: "trans_mepay",
		// 	label: "Instant Payment",
		// },
		{
			code: "instant_payment",
			label: "Instant Payment",
		},
		{
			code: "credit_card",
			label: "Credit Card",
		},
		{
			code: "e_wallet",
			label: "E-Wallet",
		},
		{
			code: "other",
			label: "Bank Transfer and Other Payment",
		},
	],
	DUMMY_BRAND: {
		limit_info: 10,
		tipe_data: "brand_campaign",
		endpoint: "/app/v1/magento/product?limit=6&page=1&brand=100&sort=random",
		title: "Avoskin",
		web_view_all_url: "/brands/avoskin",
		has_more: false,
		category_slug: "",
		short_description: "ONLY TODAY - DISCOUNT UP TO 60%",
		// short_description: "123456789012345678901234567890",
		description: "Discount up to 30% off only on 26 December 2022 until 10 January 2023! Discount up to 30% off only on 26 December 2022 until 10 January 2023! 12345678",
		color: "#000000",
		background_color: "#FFFFFF",
		image: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/beauty_studio/logo-fd-studio.png",
		position: 2,
		data: [
			{
				category: [
					{
						attribute_set_id: 3,
						desc: "",
						category_path: "flash-sale",
						category_slug: "flash-sale",
						entity_id: 127,
						parent_id: 2,
						position: 8,
						flashsale_from: "2023-01-02 15:20:00",
						flashsale_to: "2023-01-31 07:59:00",
						flashsale_status: "open",
						category_name: "Flash Sale",
						image: null,
						thumbnail: null,
						include_in_menu: "0",
						icon: null,
						icon_hover: null,
						banner: null,
						level: 2,
						is_flashsale_category: true,
						is_active: 1,
						is_virtual: false,
						placement: "magento_flash_sale",
						meta: {
							meta_title: "",
							meta_description: "",
							meta_keywords: null,
						},
						server_time: "2023-01-05T10:00:57+07:00",
						from_date: "2023-01-02T15:20:00+00:00",
						to_date: "2023-01-31T07:59:00+00:00",
					},
				],
				products: [
					{
						sku: "123321",
						image_url: "https://magento.femaledaily.net/media/catalog/product/1/1/11.jpeg",
						avg_rating: 4.4,
						review_count: 12,
						id: 929,
						name: "Sample Configurable Product",
						slug: "sample-configurable-product",
						brands: {
							brand_name: "#Be Real",
							brand_slug: "be-real",
							brand_id: 226,
						},
						price: 90000,
						promotion: null,
						discount_label: "10%",
						regular_price: 100000,
						type_id: "configurable",
						qty: 293,
						fdbr_product_id: "28623",
						is_in_stock: true,
						is_salable: true,
						is_eligible: true,
						configurable_item_options: [
							{
								option_id: 185,
								option_value: 13,
							},
							{
								option_id: 186,
								option_value: 56,
							},
						],
						meta: {
							meta_title: "Jual Sample Configurable Product #Be Real | Female Daily Studio",
							meta_description: "Jual Sample Configurable Product #Be Real asli dan terjamin pengirimannya. Temukan produk kecantikan lainnya di Female Daily Studio.",
							meta_keywords: "sample-configurable-product",
						},
					},
					{
						sku: "BS-001-00008-00-00",
						image_url: "https://magento.femaledaily.net/media/catalog/product/a/e/aeris_-_brush_a19_-_1.jpg",
						avg_rating: 3.7,
						review_count: 6,
						id: 896,
						name: "A19 - Flat Concealer / Definer",
						slug: "a19-flat-concealer-definer",
						brands: {
							brand_name: "AERIS BEAUTE",
							brand_slug: "aeris-beaute",
							brand_id: 2,
						},
						price: 25000,
						promotion: null,
						discount_label: "16.7%",
						regular_price: 30000,
						type_id: "simple",
						qty: 63,
						fdbr_product_id: "48105",
						is_in_stock: true,
						is_salable: true,
						is_eligible: true,
						configurable_item_options: null,
						meta: {
							meta_title: "Jual A19 - Flat Concealer / Definer AERIS BEAUTE | Female Daily Studio",
							meta_description: "Jual A19 - Flat Concealer / Definer AERIS BEAUTE asli dan terjamin pengirimannya. Temukan produk kecantikan lainnya di Female Daily Studio.",
							meta_keywords: "a19-flat-concealer-definer",
						},
					},
					{
						sku: "BS-136-00006-00-00",
						image_url: "https://magento.femaledaily.net/media/catalog/product/b/e/be544cd6-2334-4770-8a3d-710422c3b816.jpeg",
						avg_rating: 5,
						review_count: 5,
						id: 778,
						name: "Pearl Shea Butter Hydrogel Mask",
						slug: "pearl-shea-butter-hydrogel-mask",
						brands: {
							brand_name: "KOELF",
							brand_slug: "koelf",
							brand_id: 98,
						},
						price: 34000,
						promotion: null,
						discount_label: "12.8%",
						regular_price: 39000,
						type_id: "simple",
						qty: 101,
						fdbr_product_id: "49009",
						is_in_stock: true,
						is_salable: true,
						is_eligible: true,
						configurable_item_options: null,
						meta: {
							meta_title: "Jual Pearl Shea Butter Hydrogel Mask KOELF | Female Daily Studio",
							meta_description: "Jual Pearl Shea Butter Hydrogel Mask KOELF asli dan terjamin pengirimannya. Temukan produk kecantikan lainnya di Female Daily Studio.",
							meta_keywords: "pearl-shea-butter-hydrogel-mask",
						},
					},
					{
						sku: "BS-156-00006-00-01",
						image_url: "https://magento.femaledaily.net/media/catalog/product/k/l/kleveru_ceramide_calm_organic_oil_15ml1_2.jpg",
						avg_rating: null,
						review_count: 0,
						id: 752,
						name: "Ceramide Calm Organic Oil",
						slug: "ceramide-calm-organic-oil",
						brands: {
							brand_name: "KLEVERU",
							brand_slug: "kleveru",
							brand_id: 214,
						},
						price: 119320,
						promotion: null,
						discount_label: "4%",
						regular_price: 124320,
						type_id: "simple",
						qty: 79,
						fdbr_product_id: "49309",
						is_in_stock: true,
						is_salable: true,
						is_eligible: true,
						configurable_item_options: null,
						meta: {
							meta_title: "Jual Ceramide Calm Organic Oil KLEVERU | Female Daily Studio",
							meta_description: "Jual Ceramide Calm Organic Oil KLEVERU asli dan terjamin pengirimannya. Temukan produk kecantikan lainnya di Female Daily Studio.",
							meta_keywords: "ceramide-calm-organic-oil",
						},
					},
					{
						sku: "BS-047-00013-00-00",
						image_url: "https://magento.femaledaily.net/media/catalog/product/s/t/studio_tropik_fresh_skin_barrier_cream_texture_1_of_2_.jpg",
						avg_rating: null,
						review_count: 0,
						id: 209,
						name: "Fresh Skin Barrier Cream",
						slug: "fresh-skin-barrier-cream",
						brands: {
							brand_name: "STUDIO TROPIK",
							brand_slug: "studio-tropik",
							brand_id: 177,
						},
						price: 194000,
						promotion: null,
						discount_label: "2.5%",
						regular_price: 199000,
						type_id: "simple",
						qty: 0,
						fdbr_product_id: "49103",
						is_in_stock: true,
						is_salable: false,
						is_eligible: false,
						configurable_item_options: null,
						meta: {
							meta_title: "Jual Fresh Skin Barrier Cream STUDIO TROPIK | Female Daily Studio",
							meta_description: "Jual Fresh Skin Barrier Cream STUDIO TROPIK asli dan terjamin pengirimannya. Temukan produk kecantikan lainnya di Female Daily Studio.",
							meta_keywords: "fresh-skin-barrier-cream",
						},
					},
				],
			},
		],
	},

};
